// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"38b3fe2a","455":"3d64d4ad","977":"c9a9b849"}[chunkId] + ".chunk.js";
};